export * from './BoxInput';
export * from './StrictInput';
export * from './RadioInput';
export * from './CheckboxInput';
export * from './NestedArrayObjectField';
export * from './NestedArrayBooleanField';
export * from './NestedArrayStringField';
export * from './RenderDatePicker';
export * from './DidYouMeanCombo';
export * from './AutoCompleteField';
export { default as normalizeFullWidth } from './normalizers';

export const preventEmptyStringInitialization = function (event, newValue, prevValue) {
  if (prevValue === null && newValue === '') {
    event.preventDefault();
  }
};

export const preventInvalidDateInitialization = function (event, newValue, prevValue) {
  if (newValue === 'Invalid date') {
    event.preventDefault();
  }
};

export const preventNullInitialization = function (event, newValue, prevValue) {
  if (prevValue === undefined && newValue === '') {
    event.preventDefault();
  }
};
